
$(document).on('click', '.custom-open-size-chart, a[href="#size-chart"]', function(e) {
  e.preventDefault(); // prevent jump to anchor
  $("#size-chart-popup").addClass('visible');
  $('body').addClass('no-scroll');
});
document.addEventListener('DOMContentLoaded', function(){
  $("#size-chart-popup").on("click", function(e){
    if (e.target == $(this)[0]){
      $(this).removeClass('visible');
      $('body').removeClass('no-scroll');
    }
  });
  
  if ($(".accordion")) {
      var acc = document.getElementsByClassName("accordion-btn");
      var i;

      for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
          this.classList.toggle("active");
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = 20+panel.scrollHeight + "px";
          }
        });
      }
     }
     $('.to_block').on('click', function(e){
      $('html,body').stop().animate({ scrollTop: $('#size_table').offset().top }, 1000);
      e.preventDefault();
    });
});
